export const reduceCreateNotificationMessage = (
  state,
  { payload: { message, type } },
) => ({
  ...state,
  notification: { message, type },
});
